module.exports = __webpack_public_path__ + "src/assets/models/micropipette/holder_1.fbx";